import { noop } from "lodash";
import { Dispatch, SetStateAction, createContext } from "react";
import { Notification } from "./types";
import { CashflowItems } from "./backend/types-v2";

export const AppContext = createContext<{
  userData: CashflowItems;
  setUserData: Dispatch<SetStateAction<CashflowItems>>;
  setNotification: Dispatch<SetStateAction<Notification | null>>;
  notification: Notification | null;
}>({
  userData: [],
  setUserData: noop,
  setNotification: noop,
  notification: { message: "", action: "delete" },
});
